import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: {
    quarter,
    year,
    name,
    taxId
  },
} = checkout;

const validation2 = Yup.object().shape({
  [quarter.name]: Yup.number().required(quarter.errorMsg),
  [year.name]: Yup.number().required(year.errorMsg),
  [taxId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
  .required(taxId.errorMsg),
  [name.name]: Yup.string().required(name.errorMsg),

});

export default validation2;
